module.exports = __webpack_public_path__ + "banquet/components/images/chevron_black.a3656d94f8dac287871a930172dd2c54.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/chevron_black.svg
// module id = 1701
// module chunks = 1